var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 149,
    viewBox: "0 0 173 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_29368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.4973 0.794189L1.32422 148.176H171.67L86.4973 0.794189Z",
    fill: "#F6B21A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.676 149H1.32593C1.02968 149 0.759686 148.843 0.609687 148.588C0.463438 148.333 0.463438 148.018 0.609687 147.764L85.7866 0.382118C86.0828 -0.127373 86.9228 -0.127373 87.2191 0.382118L172.392 147.76C172.538 148.015 172.538 148.329 172.392 148.584C172.242 148.843 171.968 149 171.676 149ZM2.75842 147.348H170.243L86.4991 2.44631L2.75842 147.348Z",
    fill: "#2B292D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3652 114.25H76.6328V133.963H96.3652V114.25Z",
    fill: "#2B292D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3681 104.985H76.632L74.9258 51.1777H98.0744L96.3681 104.985Z",
    fill: "#2B292D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_29368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 149,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSign);
export default __webpack_public_path__ + "static/media/warning-sign.65dd1c03a30278cfff4ee3a5df60193c.svg";
export { ForwardRef as ReactComponent };